/**
 * @deprecated
 * Created by 1 on 2017/9/4.
 * bean管理扩展接口,仅sdk内部使用。
 */
'use strict';
define([
    '../utils/CommonUtil',
    '../utils/ResourceUtil',
    '../utils/LoggerUtil'
],function(
    CommonUtil,
    ResourceUtil,
    LoggerUtil
){
    var BEAN_TYPES={
        'NORMAL':'normal',//普通类,自动实例化,默认值
        'CLASS':'class',//静态类,不实例化
        'PLUGIN':'plugin',//第三方库或者插件,只加载
    }
    var fns={
        /**
         * 合并参数和默认的beans，检查依赖
         * @method
         * @param defaultBeans {Array}   默认的bean
         * @param optBeans {Array}       参数项bean
         * @private
         */
        _mergeAndCheckBeans:function(defaultBeans,optBeans){
            var temp={};
            if(CommonUtil.isArray(defaultBeans)){
                //默认的bean
                for(var i=0,len=defaultBeans.length;i<len;i++){
                    var bean=defaultBeans[i];
                    if(bean){
                        temp[bean.id]=bean;
                    }
                }
            }
            if(CommonUtil.isArray(optBeans)){
                //参数里的bean
                for(var j=0,len=optBeans.length;j<len;j++){
                    var bean=optBeans[j];
                    if(bean){
                        if(temp[bean.id]){
                            LoggerUtil.info('override bean :'+bean.id+'')
                        }
                        temp[bean.id]=bean;
                    }
                }
            }
            var beans=[];
            /**
             * 是否是打包模式
             */
            if(this._isPackMode()){
                for(var k in temp){
                    var bean =temp[k];
                    if(bean){
                        if(!bean.path){
                            delete bean.path;
                        }else if(!this._isGlobalVar(bean.path)){
                            //替换path里的占位符
                            bean.path=replacePathHolder.call(this,bean.path);
                        }
                        //
                        beans.push(bean);
                    }
                }
            }else{//非打包状态
                for(var k in temp){
                    /**
                     * 处理没有配置path的情况；
                     * 要求id与文件名一致；
                     * 根据目录规则自动拼接
                     */
                    var bean =temp[k];
                    if(bean){
                        if(!CommonUtil.isString(bean.path)){
                            var type=this._getBeanTypeById(bean.id);
                            bean.path=this.getResourcePath()+'/js/'+type+'/'+bean.id+'.js';
                        }
                        if(!this._isGlobalVar(bean.path)){
                            //替换path里的占位符
                            bean.path=replacePathHolder.call(this,bean.path);
                        }
                        //
                        beans.push(bean);
                    }
                }
            }
            //
            this.options.beans=beans;
            //替换path里的占位符
            function replacePathHolder(path){
                var holder={
                    //根目录
                    base: ResourceUtil.getBasePath(),
                    //当前控件/模块的目录，如tsemap-api/src/controls/DemoCtrl/
                    resource:this.getResourcePath()
                };
                return CommonUtil.replacePlaceHolder(holder,path);
            }
        },
        /**
         * 是否是打包模式
         * 打包状态下对象有BEANS属性，保存bean的class对象
         * @returns {boolean|*}
         * @private
         */
        _isPackMode:function(){
            return CommonUtil.isObject(this.BEANS);
        },
        /**
         * 提取bean的path
         * @method
         * @returns {Array}
         * @private
         */
        _extractBeanPath:function(){
            var beans=this.options.beans;
            var deps=[];
            for(var i=0,len=beans.length;i<len;i++){
                var bean=beans[i];
                if(CommonUtil.isString(bean.path)){
                    //非全局变量
                    if(!this._isGlobalVar(bean.path)){
                        deps.push(bean.path);
                    }
                }
            }
            return deps;
        },
        //path 是否是全局变量
        _isGlobalVar:function(path){
            return CommonUtil.isString(path)&&
                /^var\:.*$/.test(path);
        },
        /**
         * 根据id获取变量
         * @method
         * @param {String} id - 必填
         * @returns {*|null}
         */
        getBean:function(id){
            return this._beans[id]||null;
        },
        /**
         * 初始化bean
         * @method
         * @private
         */
        _initializeBean:function(id,clazzArr){
            var bean=this._beans[id];
            var isPlugin=false;
            var optBeans=this.options.beans;
            if(bean==null){
                for(var i=0,len=optBeans.length;i<len;i++){
                    var b=optBeans[i],
                        props=b.properties||[];
                    if(b&&b.id==id){
                        try{
                            //静态
                            if(b.type==BEAN_TYPES.CLASS){
                                bean=clazzArr[i];
                                this._beans[b.id]=bean;
                                //
                                if(CommonUtil.isArray(props)
                                    &&props.length>0
                                    &&CommonUtil.isObject(bean.prototype)){
                                    var options=bean.prototype.options||{};
                                    var opts=fetchPorps.call(this,props,clazzArr,optBeans);
                                    opts=constructOpts.call(this,b,opts);
                                    for(var key in opts){
                                        options[key]=opts[key];
                                    }
                                    bean.prototype.options=options;
                                }
                            }else if(b.type==BEAN_TYPES.PLUGIN){//第三方插件
                                isPlugin=true;
                                //
                                bean=clazzArr[i];
                                this._beans[b.id]=bean;
                            }else{
                                var opts=fetchPorps.call(this,props,clazzArr,optBeans);
                                opts=constructOpts.call(this,b,opts);
                                if(CommonUtil.isFunction(clazzArr[i]))
                                    bean=new clazzArr[i](opts);
                                else if(CommonUtil.isObject(clazzArr[i]))
                                    bean=clazzArr[i];
                                this._beans[b.id]=bean;
                            }
                        }catch(e){
                            throw(new Error('failed to construct bean ['+id+']\r\n message: '+e.message));
                        }
                        break;
                    }
                }
            }
            //!isPlugin 处理第三方库无返回值的情况
            if(!isPlugin&&bean==null){
                throw(new Error('bean ['+id+'] cannot be initialized !'));
            }
            return bean;
            /**
             * @param props
             */
            function fetchPorps(props,clazzArr,beans){
                var opts={};
                //获取所有beanId
                var beanIds={};
                for(var i=0,len=beans.length;i<len;i++){
                    var bean=beans[i];
                    if(bean&&bean.id){
                        var str='${'+bean.id+'}';
                        beanIds[str]=bean.id;
                    }
                }
                for(var i =0,len=props.length;i<len;i++){
                    var prop=props[i],
                        name=prop.name,
                        value=prop.value;
                    //如果是字符串
                    if(CommonUtil.isString(value)){
                        //如果注入的是bean
                        if(beanIds.hasOwnProperty(value)){
                            var beanId=beanIds[value];
                            opts[name]=this._initializeBean(beanId,clazzArr);
                        }else{//其他
                            var phReg = /(\$\{[\w\.\_\-\d]{0,}\})/g,
                                attrReg = /([\w\_\-\d]+)/g;
                            //匹配占位符
                            var phArr = value.match(phReg);
                            if(CommonUtil.isArray(phArr)){
                                for(var k=0,ll=phArr.length;k<ll;k++){
                                    var holder=phArr[k];
                                    var attrArr=holder.match(attrReg);
                                    if(CommonUtil.isArray(attrArr)&&
                                        attrArr.length>0){
                                        var attrName=attrArr.join('.');
                                        var replacement=CommonUtil.getValByVarPath(attrName);
                                        if(value==='${'+attrName+'}'){
                                            value=replacement;
                                        }else{
                                            value=value.replace(holder,replacement);
                                        }
                                    }
                                }
                            }
                            opts[name]=value;
                        }
                    }else{
                        opts[name]=value;
                    }
                }
                return opts;
            }

            /**
             * @param bean
             * @param opts
             * @returns {*}
             */
            function constructOpts(bean,opts){
                //全局事件对象
                opts.appEvent=this.appEvent;
                //控件/模块对应国际化变量
                opts.locale=ResourceUtil.getLocaleValue(this.options.name)||{};
                //控件/模块的options属性
                opts.parentOpts=this.options;
                _constructFn.call(this,bean.id,opts);
                return opts;
            }

            /**
             * 根据bean id的后缀处理不同的bean的默认参数
             * @param id
             * @param opts
             * @private
             */
            function _constructFn(id,opts){
                //
                var obj={
                    'component':function(optss){
                        optss.map=this.map;
                    },
                    'dispatcher':function(optss){

                    },
                    'view':function(optss){
                        optss.imgPath=this._imgPath;
                        optss.cssPath=this._cssPath;
                        optss.htmlPath=this._htmlPath;
                        optss.configPath=this._configPath;
                    },
                    'service':function(optss){
                        optss.configPath=this._configPath;
                    }
                }
                var type=this._getBeanTypeById(id);
                if(type&&obj[type]){
                    obj[type].call(this,opts);
                }
            }
        },
        /**
         * 通过id命名规则获取类型
         * @param id
         * @returns {*}
         * @private
         */
        _getBeanTypeById:function(id){
            var obj={
                '^.*component$':'component',
                '^.*dispatcher$':'dispatcher',
                '^.*view$':'view',
                '^.*service$':'service'
            }
            var type='misc';//其他
            if(id){
                id=id.toLowerCase();
            }
            for(var k in obj){
                if(new RegExp(k,'i').test(id)){
                    type=obj[k];
                    break;
                }
            }
            return type;
        },
        /**
         * 初始化bean
         * @method
         * @private
         */
        _initializeBeans:function(){
            //
            var clazzArr=[];
            var beans=this.options.beans,
                beanClazzs=this.BEANS;
            var requireIndex=0;
            for(var i=0,len=beans.length;i<len;i++){
                var bean=beans[i];
                if(CommonUtil.isString(bean.path)){
                    if(this._isGlobalVar(bean.path)){
                        //获取全局变量
                        clazzArr.push(CommonUtil.getValByVarPath(bean.path.replace(/var:/g,'')));
                    }else{
                        clazzArr.push(arguments[requireIndex++]);
                    }
                }else{
                    var clazz=beanClazzs[bean.id];
                    if(clazz){
                        clazzArr.push(clazz);
                    }else{
                        throw(new Error('bean :'+bean.id+' clazz not defined!'));
                    }
                }
            }
            //

            for(var i=0,len=beans.length;i<len;i++){
                var bean=beans[i];
                this._initializeBean(bean.id,clazzArr);
            }
        },
        /**
         * 开始所有的调度
         * @private
         */
        _activateDispatchers:function(){
            for(var id in this._beans){
                var bean=this._beans[id];
                if(bean){
                    if(this._getBeanTypeById(id)==='dispatcher'){
                        this.getBean(id).dispatch();
                    }
                }
            }
        },
        /**
         * 销毁
         * @method
         * @private
         */
        _destroyBeans:function(){
            for(var k in this._beans){
                var bean=this._beans[k];
                if(bean.destroy){
                    try{
                        bean.destroy();
                    }catch(e){}
                }
                this._beans[k]=null;
                delete this._beans[k];
            }
        }
    };
    /****
     * 初始化
     *
     */
    function initializeHandler(options){
        var optBeans=options.beans;
        delete options.beans;
//      //资源的相对目录
        if(options.hasOwnProperty('resourcePath')){
            //如果指定，则清除this.BEANS属性，加载非打包的资源类
            this.BEANS=null;
            this.setResourcePath(options.resourcePath);//控件使用时可定制
        }
        var path=this.getResourcePath();
        this._staticPath=options.staticPath||ResourceUtil.getStaticPath();
        this._cssPath=options.cssPath||path+'css/';
        this._configPath=options.configPath||path+'config/';
        //图片都放在static下，调整
        this._imgPath=options.imgPath||path+'img/';
        this._htmlPath=options.htmlPath||path+'html/';
        //加载配置文件
        var config={};
        if(CommonUtil.isString(this.options.config)){
            config=CommonUtil.getConfig({
                url:this._configPath+this.options.config,
                async:false
            });
        }
        var defaultBeans=null;
        if(CommonUtil.isObject(config)){
            defaultBeans=config.beans;
            delete config.beans;
            for(var k in config){
                //附加配置中的属性到this.options下
                if(this.options.hasOwnProperty(k)){
                    continue;
                }
                this.options[k]=config[k];
            }
        }
        //beans
        this._beans={};
        //处理配置的bean
        this._mergeAndCheckBeans(defaultBeans,optBeans);
    }
    /**
     * 打开的处理
     * @param clazz
     */
    function openHandler(){
        var self=this;
        var beanPaths=this._extractBeanPath();
        /**
         * 加载
         */
        //require兼容模式
        if(window.hasOwnProperty('requireNoConflict')){
            window['requireNoConflict'](beanPaths,function(){
                start.apply(self,arguments);
            });
        }else if(CommonUtil.isFunction(window['require'])&&
            CommonUtil.isFunction(window['define'])){//require
            window['require'](beanPaths,function(){
                start.apply(self,arguments);
            });
        }else{
            start.apply(self,[]);
        }
        function start(){
            /**
             * 初始化bean 并注入属性
             */
            this._initializeBeans.apply(this,arguments);
            /**
             * 执行所有的dispatcher的dispatch方法
             */
            this._activateDispatchers();
            /**
             * BEAN加载完成的回调
             */
            this.fire('BEAN_INITIALIZED',{});
        }
    }
    function closeHandler(){
        /**
         * 销毁所有bean
         */
        this._destroyBeans();
    }

    /**
     * 关闭的处理
     * @param clazz
     */
    var fn=function(clazz){
        if(clazz&&
            clazz.prototype){
            if(clazz.prototype.initialize){
                var initialize=clazz.prototype.initialize;
                clazz.prototype.initialize=function(options){
                    initialize.apply(this,arguments);
                    initializeHandler.apply(this,arguments);
                }
            }
            if(clazz.prototype.TYPE=='Control'){
                var onAdd=clazz.prototype.onAdd;
                clazz.prototype.onAdd=function(){
                    onAdd.call(this);
                    openHandler.call(this);
                }
                var onRemove=clazz.prototype.onRemove;
                clazz.prototype.onRemove=function(){
                    onRemove.call(this);
                    closeHandler.call(this);
                }
            }else if(clazz.prototype.TYPE=='Module'){
                var onOpen=clazz.prototype.onOpen;
                clazz.prototype.onOpen=function(){
                    onOpen.call(this);
                    openHandler.call(this);
                }
                var onClose=clazz.prototype.onClose;
                clazz.prototype.onClose=function(){
                    onClose.call(this);
                    closeHandler.call(this);
                }
            }

            for(var k in fns){
                clazz.prototype[k]=fns[k];
            }
        }
    }
    return {
        enable:fn
    };
});